import da from './locales/da.json';
import de from './locales/de.json';
import en from './locales/en.json';
import eo from './locales/eo.json';
import es from './locales/es.json';
import esMX from './locales/es-MX.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import nl from './locales/nl.json';
import no from './locales/no.json';
import ptBR from './locales/pt-BR.json';
import ru from './locales/ru.json';
import sv from './locales/sv.json';
import th from './locales/th.json';
import zhCN from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';
export const commonLocales = {
    da,
    de,
    en,
    eo,
    es,
    esMX,
    fi,
    fr,
    it,
    ja,
    ko,
    nl,
    no,
    ptBR,
    ru,
    sv,
    th,
    zhCN,
    zhTW,
};
//# sourceMappingURL=commonLocales.js.map